<shrd-uic-ribbon
  [containerClass]="'container-fluid mb-0 overflow-hidden' + (!inModal ? ' pt-md-1 ps-md-0 pe-md-0' : '')"
  [fixed]="false"
  *ngIf="!inModal || tabs.length > 1"
>
  <div class="col-24" *ngIf="!inModal">
    <div class="content-box mb-0 heading-md text-bold">
      <span>{{ 'header.meta.contactUs' | i18next }}</span>
    </div>
  </div>
  <div class="col-24 bl-h-3" *ngIf="tabs.length > 1">
    <shrd-uic-tab-group class="contact-tab-group content-box ps-md-0 pe-md-0" *ngIf="loaded$ | async" @tabsFade>
      <shrd-uic-tab
        *ngFor="let tab of tabs"
        [active]="tab === activeTab"
        [contentId]="tabContentIdPrefix + tab"
        [id]="'tab-contact-id-' + tab"
      >
        {{ 'header.contact.tabNames.' + tab | i18next }}
      </shrd-uic-tab>
    </shrd-uic-tab-group>
  </div>
</shrd-uic-ribbon>
